import React from 'react'
import { useParams } from 'react-router-dom'

import { SmsTicketsWrapper } from '../../components'

export default function SmsTicketsPage() {
  const { token } = useParams()

  return <SmsTicketsWrapper token={token} />
}
